// Picks the open/close option `code` Cylindo expects for the wanted viewer state.
//
// Closed is spelled CLOSE on older products and CLOSED on newer ones. Anything else is
// an open option.
//
// For open, use plain OPEN when the product has it. Newer products drop OPEN and name a
// render per recliner count instead ("2 SEAT RECLINING"), so match on the selected count.
//
// Return null when the selected count has no render. The remaining open options are
// other seat counts, so picking one would show the wrong pose (CON-8732).
const CLOSED_OPTION_CODES = ['CLOSE', 'CLOSED'];

const normalizeCode = code =>
  String(code)
    .trim()
    .toUpperCase();

const resolveCylindoOpenCloseOption = ({
  isOpen,
  selectedReclinerCount,
  cylindoOptions,
} = {}) => {
  if (!Array.isArray(cylindoOptions) || cylindoOptions.length === 0) {
    return null;
  }

  if (!isOpen) {
    const closed = cylindoOptions.find(opt =>
      CLOSED_OPTION_CODES.includes(normalizeCode(opt.code))
    );
    return closed ? closed.code : null;
  }

  const openOptions = cylindoOptions.filter(
    opt => !CLOSED_OPTION_CODES.includes(normalizeCode(opt.code))
  );
  const plainOpen = openOptions.find(opt => normalizeCode(opt.code) === 'OPEN');
  const match = selectedReclinerCount
    ? plainOpen ||
      openOptions.find(opt =>
        normalizeCode(opt.code).startsWith(`${selectedReclinerCount} `)
      )
    : plainOpen || openOptions[0];
  return match ? match.code : null;
};

export default resolveCylindoOpenCloseOption;
